import client from "./http.client"
import store from "@/store"

class PlaybookService {
  getPlaybooks() {
    return client.get(`/api/organizations/${store.state.organization.id}/playbooks/?page_size=100`)
  }
  createPlaybook(data) {
    return client.post(`/api/organizations/${store.state.organization.id}/playbooks/`, data)
  }
  getPlaybook(id) {
    return client.get(`/api/organizations/${store.state.organization.id}/playbooks/${id}/`)
  }
  updatePlaybook(id, data) {
    return client.patch(`/api/organizations/${store.state.organization.id}/playbooks/${id}/`, data)
  }
  duplicatePlaybook(id) {
    return client.post(`/api/organizations/${store.state.organization.id}/playbooks/${id}/duplicate/`)
  }
  deletePlaybook(id) {
    return client.delete(`/api/organizations/${store.state.organization.id}/playbooks/${id}/`)
  }
  getPlaybookExecutions(id, params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/playbooks/${id}/executions/`, { params })
  }
  triggerPlaybookExecution(id, data) {
    return client.post(`/api/organizations/${store.state.organization.id}/playbooks/${id}/trigger/`, data)
  }
  getPlaybookExecution(playbook_id, execution_id) {
    return client.get(`/api/organizations/${store.state.organization.id}/playbooks/${playbook_id}/executions/${execution_id}/`)
  }
  delePlaybookExecution(playbook_id, execution_id) {
    return client.delete(`/api/organizations/${store.state.organization.id}/playbooks/${playbook_id}/executions/${execution_id}/`)
  }
  createTag(data, params = {}) {
    return client.post(`/api/organizations/${store.state.organization.id}/playbooks-tags/`, data, { params })
  }
  updateTag(id, data, params = {}) {
    return client.patch(`/api/organizations/${store.state.organization.id}/playbooks-tags/${id}/`, data, { params })
  }
  getTags(params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/playbooks-tags/`, { params })
  }
  deleteTag(id, params = {}) {
    return client.delete(`/api/organizations/${store.state.organization.id}/playbooks-tags/${id}`, { params })
  }
}

export default new PlaybookService()
